import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { MenuItem } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';
import { LoginService } from '../services/login.service';
import { OktaAuthService } from 'src/app/services/okta.service';

@Component({
  selector: 'ness-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  providers: [ CookieService ]
})
export class AccountComponent {
  static userInfo: ServerModels.UserInfoViewModel = null;
  menuItems: MenuItem[] = [
    { label: 'User Profile', icon: 'far fa-user', routerLink: ['/account/userprofile'] }
  ];

  private _showUserInfo: boolean = false;
  get showUserInfo(): boolean {
    return this._showUserInfo;
  }

  set showUserInfo(b: boolean) {
    this._showUserInfo = b;
  }

  get userDisplayName(): string {
    return AccountComponent.userInfo?.FirstName + ' ' + AccountComponent.userInfo?.LastName;
  }

  constructor(private loginService: LoginService,
    private oktaAuth: OktaAuthService,
    private router: Router,
    private cookieService: CookieService,
    private authService: AuthService) {
    this.loginService.userInfoData$.subscribe(
      (info: ServerModels.UserInfoViewModel) => {
        AccountComponent.userInfo = info;
        this.showUserInfo = AccountComponent.userInfo?.Roles?.length > 0;
      }
    );
  }

  public logout() {
    let refreshToken: string = sessionStorage.getItem(environment.authRefreshTokenStorageKey);
    this.loginService.logout(refreshToken).subscribe({
      next: () => {
        this.logoutCallback();
      },
      error: (err:any) => {
        this.logoutCallback();
      }
    });
  }

  public openHelpLink() {
    this.router.navigate(['/help']);
  }

  private async logoutCallback() {
    this.loginService.nextUserInfo(null);
    this.cookieService.remove(environment.authCookieStorageKey, { domain: environment.authCookieDomainKey });
    this.authService.clearClaims();
    sessionStorage.clear();
    
    // Set logout sesstion storage for current logged in user.
    // User will not login to NESS automatically.
    // User will not logged out from Okta session.
    sessionStorage.setItem('logout', JSON.stringify(true));

    // the Commented out code will force user to logout from all current okta sessions
    // await this.oktaAuth.logout();

    // Redirect user back to login page
    this.router.navigate(['/login']);    
  }
}
